/* tslint:disable */
/* eslint-disable */
/**
 * zbo-connector API
 * zbo-connector - client
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI } from '../base';
/**
 * ZbocControllerApi - axios parameter creator
 * @export
 */
export const ZbocControllerApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Stažení obsahu dokumentu
         * @param {string} extPripadId
         * @param {number} dokumentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDokument: (extPripadId_1, dokumentId_1, ...args_1) => __awaiter(this, [extPripadId_1, dokumentId_1, ...args_1], void 0, function* (extPripadId, dokumentId, options = {}) {
            // verify required parameter 'extPripadId' is not null or undefined
            assertParamExists('downloadDokument', 'extPripadId', extPripadId);
            // verify required parameter 'dokumentId' is not null or undefined
            assertParamExists('downloadDokument', 'dokumentId', dokumentId);
            const localVarPath = `/api/zboc/pripad/{extPripadId}/dokument/{dokumentId}`
                .replace(`{${"extPripadId"}}`, encodeURIComponent(String(extPripadId)))
                .replace(`{${"dokumentId"}}`, encodeURIComponent(String(dokumentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Stažení obsahu dokumentu
         * @param {number} zadostId
         * @param {number} dokumentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDokumentZadosti: (zadostId_1, dokumentId_1, ...args_1) => __awaiter(this, [zadostId_1, dokumentId_1, ...args_1], void 0, function* (zadostId, dokumentId, options = {}) {
            // verify required parameter 'zadostId' is not null or undefined
            assertParamExists('downloadDokumentZadosti', 'zadostId', zadostId);
            // verify required parameter 'dokumentId' is not null or undefined
            assertParamExists('downloadDokumentZadosti', 'dokumentId', dokumentId);
            const localVarPath = `/api/zboc/zadost/{zadostId}/dokument/{dokumentId}`
                .replace(`{${"zadostId"}}`, encodeURIComponent(String(zadostId)))
                .replace(`{${"dokumentId"}}`, encodeURIComponent(String(dokumentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Stažení dokumentů jako ZIP archiv
         * @param {string} extPripadId
         * @param {Array<number>} requestBody Množina ID dokumentů pro stažení
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDokumenty: (extPripadId_1, requestBody_1, ...args_1) => __awaiter(this, [extPripadId_1, requestBody_1, ...args_1], void 0, function* (extPripadId, requestBody, options = {}) {
            // verify required parameter 'extPripadId' is not null or undefined
            assertParamExists('downloadDokumenty', 'extPripadId', extPripadId);
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('downloadDokumenty', 'requestBody', requestBody);
            const localVarPath = `/api/zboc/pripad/{extPripadId}/dokumenty`
                .replace(`{${"extPripadId"}}`, encodeURIComponent(String(extPripadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Stažení dokumentů jako ZIP archiv
         * @param {number} zadostId
         * @param {Array<number>} requestBody Množina ID dokumentů pro stažení
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDokumentyZadosti: (zadostId_1, requestBody_1, ...args_1) => __awaiter(this, [zadostId_1, requestBody_1, ...args_1], void 0, function* (zadostId, requestBody, options = {}) {
            // verify required parameter 'zadostId' is not null or undefined
            assertParamExists('downloadDokumentyZadosti', 'zadostId', zadostId);
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('downloadDokumentyZadosti', 'requestBody', requestBody);
            const localVarPath = `/api/zboc/zadost/{zadostId}/dokumenty`
                .replace(`{${"zadostId"}}`, encodeURIComponent(String(zadostId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} zadostId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZadostById: (zadostId_1, ...args_1) => __awaiter(this, [zadostId_1, ...args_1], void 0, function* (zadostId, options = {}) {
            // verify required parameter 'zadostId' is not null or undefined
            assertParamExists('getZadostById', 'zadostId', zadostId);
            const localVarPath = `/api/zboc/zadost/{zadostId}`
                .replace(`{${"zadostId"}}`, encodeURIComponent(String(zadostId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} extPripadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZadostByPripad: (extPripadId_1, ...args_1) => __awaiter(this, [extPripadId_1, ...args_1], void 0, function* (extPripadId, options = {}) {
            // verify required parameter 'extPripadId' is not null or undefined
            assertParamExists('getZadostByPripad', 'extPripadId', extPripadId);
            const localVarPath = `/api/zboc/pripad/{extPripadId}`
                .replace(`{${"extPripadId"}}`, encodeURIComponent(String(extPripadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {number} zboPripadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZadostByZboPripad: (zboPripadId_1, ...args_1) => __awaiter(this, [zboPripadId_1, ...args_1], void 0, function* (zboPripadId, options = {}) {
            // verify required parameter 'zboPripadId' is not null or undefined
            assertParamExists('getZadostByZboPripad', 'zboPripadId', zboPripadId);
            const localVarPath = `/api/zboc/zbopripad/{zboPripadId}`
                .replace(`{${"zboPripadId"}}`, encodeURIComponent(String(zboPripadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {string} extPripadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odeslatDoZbo: (extPripadId_1, ...args_1) => __awaiter(this, [extPripadId_1, ...args_1], void 0, function* (extPripadId, options = {}) {
            // verify required parameter 'extPripadId' is not null or undefined
            assertParamExists('odeslatDoZbo', 'extPripadId', extPripadId);
            const localVarPath = `/api/zboc/pripad/{extPripadId}/odeslatDoZbo`
                .replace(`{${"extPripadId"}}`, encodeURIComponent(String(extPripadId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * ZbocControllerApi - functional programming interface
 * @export
 */
export const ZbocControllerApiFp = function (configuration) {
    const localVarAxiosParamCreator = ZbocControllerApiAxiosParamCreator(configuration);
    return {
        /**
         * Stažení obsahu dokumentu
         * @param {string} extPripadId
         * @param {number} dokumentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDokument(extPripadId, dokumentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadDokument(extPripadId, dokumentId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Stažení obsahu dokumentu
         * @param {number} zadostId
         * @param {number} dokumentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDokumentZadosti(zadostId, dokumentId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadDokumentZadosti(zadostId, dokumentId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Stažení dokumentů jako ZIP archiv
         * @param {string} extPripadId
         * @param {Array<number>} requestBody Množina ID dokumentů pro stažení
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDokumenty(extPripadId, requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadDokumenty(extPripadId, requestBody, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         * Stažení dokumentů jako ZIP archiv
         * @param {number} zadostId
         * @param {Array<number>} requestBody Množina ID dokumentů pro stažení
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDokumentyZadosti(zadostId, requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.downloadDokumentyZadosti(zadostId, requestBody, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} zadostId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZadostById(zadostId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getZadostById(zadostId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} extPripadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZadostByPripad(extPripadId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getZadostByPripad(extPripadId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {number} zboPripadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZadostByZboPripad(zboPripadId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getZadostByZboPripad(zboPripadId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {string} extPripadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odeslatDoZbo(extPripadId, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.odeslatDoZbo(extPripadId, options);
                return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
            });
        },
    };
};
/**
 * ZbocControllerApi - factory interface
 * @export
 */
export const ZbocControllerApiFactory = function (configuration, basePath, axios) {
    const localVarFp = ZbocControllerApiFp(configuration);
    return {
        /**
         * Stažení obsahu dokumentu
         * @param {string} extPripadId
         * @param {number} dokumentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDokument(extPripadId, dokumentId, options) {
            return localVarFp.downloadDokument(extPripadId, dokumentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Stažení obsahu dokumentu
         * @param {number} zadostId
         * @param {number} dokumentId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDokumentZadosti(zadostId, dokumentId, options) {
            return localVarFp.downloadDokumentZadosti(zadostId, dokumentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Stažení dokumentů jako ZIP archiv
         * @param {string} extPripadId
         * @param {Array<number>} requestBody Množina ID dokumentů pro stažení
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDokumenty(extPripadId, requestBody, options) {
            return localVarFp.downloadDokumenty(extPripadId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * Stažení dokumentů jako ZIP archiv
         * @param {number} zadostId
         * @param {Array<number>} requestBody Množina ID dokumentů pro stažení
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDokumentyZadosti(zadostId, requestBody, options) {
            return localVarFp.downloadDokumentyZadosti(zadostId, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} zadostId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZadostById(zadostId, options) {
            return localVarFp.getZadostById(zadostId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} extPripadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZadostByPripad(extPripadId, options) {
            return localVarFp.getZadostByPripad(extPripadId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} zboPripadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getZadostByZboPripad(zboPripadId, options) {
            return localVarFp.getZadostByZboPripad(zboPripadId, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} extPripadId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        odeslatDoZbo(extPripadId, options) {
            return localVarFp.odeslatDoZbo(extPripadId, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * ZbocControllerApi - object-oriented interface
 * @export
 * @class ZbocControllerApi
 * @extends {BaseAPI}
 */
export class ZbocControllerApi extends BaseAPI {
    /**
     * Stažení obsahu dokumentu
     * @param {string} extPripadId
     * @param {number} dokumentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZbocControllerApi
     */
    downloadDokument(extPripadId, dokumentId, options) {
        return ZbocControllerApiFp(this.configuration).downloadDokument(extPripadId, dokumentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Stažení obsahu dokumentu
     * @param {number} zadostId
     * @param {number} dokumentId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZbocControllerApi
     */
    downloadDokumentZadosti(zadostId, dokumentId, options) {
        return ZbocControllerApiFp(this.configuration).downloadDokumentZadosti(zadostId, dokumentId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Stažení dokumentů jako ZIP archiv
     * @param {string} extPripadId
     * @param {Array<number>} requestBody Množina ID dokumentů pro stažení
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZbocControllerApi
     */
    downloadDokumenty(extPripadId, requestBody, options) {
        return ZbocControllerApiFp(this.configuration).downloadDokumenty(extPripadId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Stažení dokumentů jako ZIP archiv
     * @param {number} zadostId
     * @param {Array<number>} requestBody Množina ID dokumentů pro stažení
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZbocControllerApi
     */
    downloadDokumentyZadosti(zadostId, requestBody, options) {
        return ZbocControllerApiFp(this.configuration).downloadDokumentyZadosti(zadostId, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} zadostId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZbocControllerApi
     */
    getZadostById(zadostId, options) {
        return ZbocControllerApiFp(this.configuration).getZadostById(zadostId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} extPripadId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZbocControllerApi
     */
    getZadostByPripad(extPripadId, options) {
        return ZbocControllerApiFp(this.configuration).getZadostByPripad(extPripadId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} zboPripadId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZbocControllerApi
     */
    getZadostByZboPripad(zboPripadId, options) {
        return ZbocControllerApiFp(this.configuration).getZadostByZboPripad(zboPripadId, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} extPripadId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ZbocControllerApi
     */
    odeslatDoZbo(extPripadId, options) {
        return ZbocControllerApiFp(this.configuration).odeslatDoZbo(extPripadId, options).then((request) => request(this.axios, this.basePath));
    }
}
//# sourceMappingURL=zboc-controller-api.js.map